var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dont-print"},[_c('date-picker',{attrs:{"valueType":"format","clearable":false,"range":""},model:{value:(_vm.days),callback:function ($$v) {_vm.days=$$v},expression:"days"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }